var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "validation-observer",
        { ref: "legalEntityForm" },
        [
          _c(
            "b-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.saveLegalEntityForm.apply(null, arguments)
                },
                reset: function ($event) {
                  $event.preventDefault()
                  return _vm.clearForm.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/3 w-full" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "CNPJ", "label-for": "cnpj" } },
                      [
                        _c("validation-provider", {
                          attrs: { name: "CNPJ", rules: "required|cnpj" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: ["##.###.###/####-##"],
                                        expression: "['##.###.###/####-##']",
                                      },
                                    ],
                                    staticClass: "required",
                                    attrs: {
                                      id: "cnpj",
                                      state: errors.length > 0 ? false : null,
                                      name: "register-cnpj",
                                    },
                                    model: {
                                      value: _vm.legalEntity.cnpj,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.legalEntity, "cnpj", $$v)
                                      },
                                      expression: "legalEntity.cnpj",
                                    },
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0])),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-2/3 w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: "Razão Social",
                          "label-for": "company_name",
                        },
                      },
                      [
                        _c("validation-provider", {
                          attrs: { name: "Razão Social", rules: "required" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("b-form-input", {
                                    staticClass: "required",
                                    attrs: {
                                      id: "company_name",
                                      state: errors.length > 0 ? false : null,
                                      name: "company_name",
                                    },
                                    model: {
                                      value: _vm.legalEntity.company_name,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.legalEntity,
                                          "company_name",
                                          $$v
                                        )
                                      },
                                      expression: "legalEntity.company_name",
                                    },
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0])),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/2 w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: "Nome Fantasia",
                          "label-for": "trading_name",
                        },
                      },
                      [
                        _c("validation-provider", {
                          attrs: { name: "Nome Fantasia", rules: "required" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("b-form-input", {
                                    staticClass: "required",
                                    attrs: {
                                      id: "trading_name",
                                      state: errors.length > 0 ? false : null,
                                      name: "trading_name",
                                    },
                                    model: {
                                      value: _vm.legalEntity.trading_name,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.legalEntity,
                                          "trading_name",
                                          $$v
                                        )
                                      },
                                      expression: "legalEntity.trading_name",
                                    },
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0])),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/2 w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: _vm.$t("legal_entity.status"),
                          "label-for": "status",
                        },
                      },
                      [
                        _c("validation-provider", {
                          attrs: {
                            name: _vm.$t("legal_entity.status"),
                            rules: "required",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("b-form-radio-group", {
                                    staticClass: "required",
                                    attrs: {
                                      id: "status",
                                      name: "status",
                                      options: _vm.statusOptions,
                                    },
                                    model: {
                                      value: _vm.legalEntity.status,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.legalEntity, "status", $$v)
                                      },
                                      expression: "legalEntity.status",
                                    },
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0])),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          id: "description",
                          label: _vm.$t("legal_entity.description"),
                          "label-for": "description",
                        },
                      },
                      [
                        _c("complex-editor", {
                          attrs: { editor_data: _vm.legalEntity.description },
                          on: {
                            "update:editor_data": function ($event) {
                              return _vm.$set(
                                _vm.legalEntity,
                                "description",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm.isEdit
                ? _c(
                    "b-form-row",
                    { class: ["justify-center", _vm.inline ? "ml-auto" : ""] },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c(
                            "label",
                            { staticClass: "w-full text-left block" },
                            [_vm._v(" " + _vm._s(_vm.$t("logo_image")) + " ")]
                          ),
                          _c("image-upload", {
                            key: _vm.logoUploadURL,
                            staticClass:
                              "border-faint-grey border-solid border p-2 rounded-lg",
                            attrs: {
                              maxHeight: "100px",
                              maxWidth: "200px",
                              hint: "Tamanho recomendado: 1200×675px (paisagem, 16:9) — usada como capa do clube nos cards de busca e na página de detalhes.",
                              uploadUrl: _vm.logoUploadURL,
                            },
                            on: { "upload-complete": _vm.uploadLogoSuccess },
                            model: {
                              value: _vm.imageData,
                              callback: function ($$v) {
                                _vm.imageData = $$v
                              },
                              expression: "imageData",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isComplement
                ? _c("div", { staticClass: "vx-row mt-2 mb-2" }, [
                    _c(
                      "div",
                      { staticClass: "vx-col w-full flex gap-2 justify-end" },
                      [
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "ripple",
                                rawName: "v-ripple.400",
                                value: "rgba(255, 255, 255, 0.15)",
                                expression: "'rgba(255, 255, 255, 0.15)'",
                                modifiers: { 400: true },
                              },
                            ],
                            staticClass: "float-right",
                            attrs: {
                              variant: "primary",
                              disabled: !_vm.validateForm,
                              type: "submit",
                            },
                          },
                          [_vm._v(" Salvar ")]
                        ),
                        _c(
                          "b-button",
                          {
                            staticClass: "float-right",
                            attrs: {
                              type: "reset",
                              variant: "outline-secondary",
                            },
                          },
                          [
                            _vm._t("reset-button-text", function () {
                              return [_vm._v("Limpar")]
                            }),
                          ],
                          2
                        ),
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "ripple",
                                rawName: "v-ripple.400",
                                value: "rgba(255, 255, 255, 0.15)",
                                expression: "'rgba(255, 255, 255, 0.15)'",
                                modifiers: { 400: true },
                              },
                            ],
                            staticClass: "mr-2 float-right",
                            attrs: { variant: "outline-secondary" },
                            on: { click: _vm.goBack },
                          },
                          [_vm._v(" Voltar ")]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }